module.exports = __webpack_public_path__ + "stockLibrary/landing-modal-img-3-b140567c08ddabb712149eda8db510a4.png";